import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { clearAllAction } from 'redux/actions'

const PageNotFound = ({ i18n, t }) => {
  const startURL = i18n.language === 'en' ? process.env.REACT_APP_PAGE_NOT_FOUND_URL : process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR
  const dispatch = useDispatch()
  useEffect(() => {
    try {
      dispatch(clearAllAction())
    } catch (err) {
      console.log(err)
    }
  }, [])

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h1 style={{ display: 'flex', justifyContent: 'center' }}>{t('page_not_found.title')}</h1>
          </div>
        </div>
        <button
          className="btn-lg btn-default"
          style={{ display: 'flex', justifyContent: 'center' }}
          onClick={() => window.location.assign(startURL)}
          value={t('page_not_found.go_to_start')}
          name={t('page_not_found.go_to_start')}
        >
          {t('page_not_found.go_to_start')}
        </button>
      </div>
    </div>
  )
}

export default withTranslation('common')(PageNotFound)
